import React, {useEffect, useState} from "react";
import {withAuth} from "../../../hoc/Auth";
import Api from "../../../Api";
import Chart from "react-google-charts";
import Loader from "../../Utils/Loader"
import EmptyChart from "../EmptyChart";
import useIsMobile from "../../../hooks/useIsMobile";

export default withAuth(({token}) => {

    const [chartData, setChartData] = useState(null);
    const isMobile = useIsMobile();

    useEffect(() => {
        new Api({token}).getMpsChart().then(
            function (response) {
                if (Boolean(response.rows.length))
                    setChartData(response);
                else
                    setChartData(false);
            }
        )
    }, [])

    return (
        Boolean(chartData) ? (
            <Chart
                width={'100%'}
                height={isMobile ? '340px' : '300px'}
                chartType="PieChart"
                loader={<Loader/>}
                data={chartData}
                options={{
                    pieHole: 0.5,
                    legend: isMobile
                        ? {position: 'bottom', textStyle: {fontSize: 12}, maxLines: 4}
                        : {position: 'right', textStyle: {fontSize: 15}},
                    chartArea: isMobile ? {width: '94%', height: '62%', top: 16} : {width: '90%', height: '80%'},
                }}
                rootProps={{'data-testid': '3'}}
            />
        ) : <EmptyChart/>
    )
});



// WEBPACK FOOTER //
// ./src/Components/Charts/MpsChart/index.js